import React, { useState } from 'react'
import { Input, Form } from 'antd'
import { WrappedFieldProps } from 'redux-form'
import { InputProps } from 'antd/lib/input'
import { FormItemLabelProps } from 'antd/lib/form/FormItemLabel'
import { ChromePicker } from 'react-color'

const { Item } = Form

type Props = WrappedFieldProps & InputProps & FormItemLabelProps

const ColorPickerField = (props: Props) => {
	const {
		input,
		size,
		placeholder,
		label,
		required,
		type,
		disabled,
		style,
		meta: { error, touched },
		maxLength,
		suffix
	} = props
	const [displayColorPicker, setDisplayColorPicker] = useState<boolean>(false)

	const showColorPicker = () => {
		setDisplayColorPicker(true)
	}

	const onChangeColorPicker = (color: any) => {
		input.onChange(color.hex)
	}

	const closeColorPicker = () => {
		setDisplayColorPicker(false)
	}

	return (
		<Item label={label} required={required} style={style} validateStatus={error && touched ? 'error' : undefined}>
			<div className={'color-picker-container'}>
				<div className={'color-picker-color-background'} style={{ backgroundColor: input.value }} />
				<Input
					{...input}
					readOnly={true}
					className={'color-picker-text pl-8'}
					size={size || 'middle'}
					value={input.value}
					placeholder={placeholder}
					type={type || 'text'}
					disabled={disabled}
					maxLength={maxLength}
					suffix={suffix}
					onClick={showColorPicker}
				/>
				{displayColorPicker && (
					<div className={'color-picker-palette'}>
						<div className={'color-picker-cover'} onClick={closeColorPicker} />
						<ChromePicker color={input.value} onChange={onChangeColorPicker} disableAlpha={true} />
					</div>
				)}
			</div>
		</Item>
	)
}

export default React.memo(ColorPickerField)
